import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
export const errMsg = (e) => e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Something went wrong";
